export enum WebSocketConnectionState {
  NOT_AVAILABLE,
  CONNECTING,
  OPEN,
  CLOSING,
  CLOSED,
}
